import { Component } from '@angular/core'
import { AtomModule } from '../../atom/atom.module'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.less',
  standalone: true,
  imports: [AtomModule],
})
export class FooterComponent {
  footerLinks = [
    { name: 'Terms of Use', routerLink: '' },
    { name: 'Privacy Policy', routerLink: '' },
    { name: 'Affiliation Program', routerLink: '' },
    { name: 'Contact Us', routerLink: '' },
    { name: 'Redeem a Gift Card', routerLink: '' },
    { name: 'Latest Games News', routerLink: '' },
  ]

  footerBottomLinks = [
    { label: 'UAE', icon: 'ng-zorro:location' },
    { label: 'English', icon: 'ng-zorro:language' },
    { label: 'EUR', icon: 'ng-zorro:currency-exchange' },
  ]
}
